/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diagram_Render_Error_DescriptionInputs */



/**
* | output |
* | --- |
* | "There was an issue with the diagram syntax." |
*
* @param {Diagram_Render_Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diagram_render_error_description = /** @type {((inputs?: Diagram_Render_Error_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diagram_Render_Error_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Es gab ein Problem mit der Diagramm-Syntax.")
	return /** @type {LocalizedString} */ ("There was an issue with the diagram syntax.")
});